import axios from 'axios';

/**
 * Cliente del propio servicio de contratos. baseURL relativo ('/v1'): el vhost de
 * contratos.eneural.org sirve este build en la raíz y proxya /v1/ al backend
 * (:8003) y /auth/ al panel-api (:8000) en el mismo origen, así que no hace falta
 * CORS ni una URL absoluta.
 *
 * Login PROPIO (igual que clientes-web): postea a /auth/login (compartido con el
 * panel) y guarda el token bajo la misma clave 'token' del ecosistema Netvoice —es
 * el mismo JWT, mismo secreto compartido (ver contratos/app/auth.py)—. El rol
 * dedicado `contratos` entra por acá; el panel lo expulsa (rango 0).
 *
 * El interceptor de RESPUESTA limpia la sesión en 401: como el login vive en ESTE
 * mismo dominio, ante un 401 lo correcto es volver a la pantalla de login de este
 * sitio (App.js), nunca redirigir a mi.eneural.org (producto distinto).
 */
const api = axios.create({ baseURL: '/v1' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
    }
    return Promise.reject(error);
  }
);

/**
 * Login contra el /auth compartido del panel-api (form-urlencoded, NO JSON).
 * Guarda access_token + role y devuelve la respuesta. Usa axios directo (sin baseURL
 * '/v1'): /auth vive en otra ruta del mismo origen.
 */
export async function login(username, password) {
  const body = new URLSearchParams({ username, password });
  const r = await axios.post('/auth/login', body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
  localStorage.setItem('token', r.data.access_token);
  localStorage.setItem('role', r.data.role || '');
  if (r.data.username) localStorage.setItem('username', r.data.username);
  return r.data;
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('username');
}

export function getToken() {
  return localStorage.getItem('token');
}

export default api;
